<template>
	<div class="page-wrapper">
        <div class="w-90 mx-auto custom-form">
		
			<div class="sectionone">
				<div class="headingone">Upload prospect data from a spreadsheet into your database. Compatible file formats include: .csv, .xls, and .xlsx. 
					Your spreadsheet must have column headings in the top row, and they must match the following fields:</div>
				<div class="headingtwo"><b>Required headings:</b> First Name, Last Name and Status</div>
				<div class="headingtwo"><b>Optional headings:</b> Email, Postal Code, Tag_1, Tag_2, Tag_3, and Note</div>
				<div class="headingthree">
					<img :src="CSVDemoImage" alt="Demo CSV"/>
				</div>
				<div class="DownloadImportTemplate">
					<b-button variant="outline-primary" :href="DownloadImportTemplate">Download Import Template</b-button>
				</div>
				<div class="headingone">Imported prospects that already exist in the database (based on matching Phone Numbers) can be ignored or have their existing data
					updated/overwritten. You can select a handling option after you upload your import file.
				</div>
				<div class="DownloadImportTemplate" v-if="InputFileHide">
					<section>
						<span class="ImportProspectInput btn btn-primary btn-file">
							Import Prospects <input type="file" id="file2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="onFileChangeImport" :key="fileInputKey" required>
						</span>
						<xlsx-read :file="file">
						<xlsx-json>
							<template #default="{collection}">
							<div>{{ ImportDataCollection(collection) }}</div>
							</template>
						</xlsx-json>
						</xlsx-read>
					</section>

				</div>
			</div>

			<div class="sectiontwo" v-if="hideSectionTwoDiv">
				<div>Prospect Import Status: <b>Ready</b></div>
				<div>New Prospects: <b>{{this.CountNewProspects}}</b></div>
				<div>Existing Prospects: <b>{{this.CountExistingProspects}}</b></div>
				<div class="mt-1 manageradiobox">
					<div class="mb-2">How would you like to handle existing prospects who are in the import:</div>
						<label class="containerradio">Ignore (Data of existing prospects will be unchanged and no new data will be added)
						<input type="radio" value="1" name="radio" @change="radioBoxValidation($event)">
						<span class="checkmark"></span>
					</label>
					<label class="containerradio">Update (Data of existing prospects will be unchanged, but a new Note will be added) Recommended
						<input type="radio" value="2" name="radio" @change="radioBoxValidation($event)">
						<span class="checkmark"></span>
					</label>
					<label class="containerradio">Overwrite (All fields and data (except Phone Number and Email) will be overwritten to the values in import for the existing prospect(s). Existing Conversation and Message data will be unaffected.
						<input type="radio" value="3" name="radio" @change="radioBoxValidation($event)">
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="DownloadImportTemplate">
					<b-button type="submit" variant="outline-primary" v-if="SubmitImportbtn" @click.stop.prevent="ImportSubmit">Submit Import</b-button>
				</div>
			</div>

			<div class="sectionthree" v-if="hideSectionThreeDiv">
				<div>Prospect Import Status: <b>Complete</b></div>
				<div>Prospects Created: <b>{{createdNewProspects}}</b></div>
				<div>Prospects Updated: <b>{{updatedProspects}}</b></div>
				<div style="margin:15px 0px;">
					<b-button variant="outline-primary" @click="ResetCSVData()">Close</b-button>
				</div>
			</div>

			<div class="DownloadImportTemplate">
				<h2 v-if="LoaderShow" style="vertical-align: middle;display: inline-block;"><div class="loader4"></div></h2>
			</div>

		</div>
    </div>
</template>

<script>
	import { db } from 'src/db'
	import { mapState } from 'vuex'
	import { XlsxRead, XlsxJson } from "vue-xlsx/dist/vue-xlsx.es.js"
	export default {
		name: "Importing",
		components: {
			XlsxRead,
			XlsxJson
		},
		computed: {
            ...mapState('firebase', ['prospects', 'user'])
		},
		methods: {
			radioBoxValidation(e) {
				this.radioValue = e.target.value;
				this.SubmitImportbtn = true;
				this.InputFileHide = false;
			},
			ResetInitVal() {
				this.csvProspect = [],
				this.NewProspectData = [];
				this.ExistingProspectData = [];
				this.CountNewProspects = 0;
				this.CountExistingProspects = 0;
				this.createdNewProspects = 0;
				this.updatedProspects = 0;
				this.oldAndNewnotes = [];
				this.oldAndNewtags = [];
				this.keyHeader = [];
				this.valueHeader = [];
				this.myResult = [];
			},
			ResetCSVData() {
				this.ResetInitVal();
				this.hideSectionTwoDiv = false;
				this.hideSectionThreeDiv = false;
				this.radioValue = 0;
				this.InputFileHide = true;
				this.SubmitImportbtn = false;
				this.LoaderShow = false;
			},
			onFileChangeImport(event) {
				this.ResetInitVal();
				var fileName = document.querySelector('#file2').value;
				var extension = fileName.split('.').pop();
				if(extension == 'csv' || extension == 'xlsx' || extension == 'xls') {
					this.LoaderShow = true;
					this.file = event.target.files ? event.target.files[0] : null;
					setTimeout(() => {
						this.ImportDataValidation();
					}, 100);
				} else {
					this.fileInputKey++;
					alert('Import file must be in a .csv, .xls, or .xlsx format');
					this.hideSectionTwoDiv = false;
				}
			},
			ImportDataCollection(collection) {
				this.collection = collection;
			},
			renameProperty(obj, oldName, newName) {
				obj[newName] = obj[oldName];
				delete obj[oldName];
			},
			ImportDataValidation() {
				if(this.collection && this.collection.length) {
					
					var keyHeader1 = Object.keys(this.collection[0]);
					
					if(keyHeader1.includes('First Name') && keyHeader1.includes('Last Name') && keyHeader1.includes('Status')) {
					// if(keyHeader1[0] == 'First Name' && keyHeader1[1] == 'Last Name' && keyHeader1[2] == 'Phone Number' && keyHeader1[3] == 'Status') {
						for(var k=0; k<this.collection.length; k++) {
						
							this.keyHeader = Object.keys(this.collection[k]);
							this.valueHeader = Object.values(this.collection[k]);

							// CHECK NUMBER VALIDATION
							if(this.keyHeader.includes('Phone Number')) {
								let idexno = this.keyHeader.indexOf('Phone Number');
								var numberget = ''+this.valueHeader[idexno]+'';
								var numberr;
							
								/*var countDash = numberget.split("-").length - 1;
								if(countDash == 2) {
								const newStrNumber = numberget.replace(/-/g, ""); 
									numberr = '+1'+newStrNumber;
								} else {
									if(numberget && numberget.length == 11) {
										numberr = '+1'+numberget.substring(1);
									} else {
										numberr = this.$parseNumber(numberget);
									}
								}*/

								var numberone = numberget;
								if(numberone) {
								var numbertwo = numberone.replace(/[^0-9]/g, "");
								if(numbertwo.length == 11) {
									numberr = '+1'+numberget.substring(1);
								} else {
									numberr = '+1'+numbertwo;
								}
								} else {
									numberr = '';
								}							
								this.valueHeader[idexno] = numberr;
							}

							var columns = this.keyHeader;
							var rows = this.valueHeader;
						
							var result =  rows.reduce(function(result, field, index) {
								result[columns[index]] = field;
								return result;
							}, {})

							this.myResult = result;

							// OFFICE MANAGE
							var officenameString = this.collection[k]['Office'];
							if(officenameString) {
								var getofficeData = this.user.Offices.find(uo => uo.OfficeName == officenameString);
								if(getofficeData) {
									this.myResult['Office'] = getofficeData.OfficeId;
								} else {
									this.$delete(this.myResult, 'Office');
								}
							}

							this.$delete(this.myResult, 'Tag_1');
							this.$delete(this.myResult, 'Tag_2');
							this.$delete(this.myResult, 'Tag_3');

							var tags1 = [this.collection[k]['Tag_1'], this.collection[k]['Tag_2'], this.collection[k]['Tag_3']]; // MAKING COMMA SEPERATED ARRAY
							var tagsData1 = tags1.filter(val=>val); // REMOVE BLANK ARRAY VALUE 

							this.myResult['Tags'] = tagsData1;
							// this.myResult['DateCreated'] = Date.now();

							this.renameProperty(this.myResult, 'First Name', 'First');
							this.renameProperty(this.myResult, 'Last Name', 'Last');
							this.renameProperty(this.myResult, 'Phone Number', 'Number');
							this.renameProperty(this.myResult, 'Postal Code', 'Zip');
							this.renameProperty(this.myResult, 'Note', 'Notes');
						
							//eslint-disable-next-line
							//console.log('this.myResult', this.myResult);
						
							// if(this.myResult.Number) {
								this.csvProspect.push(this.myResult);
							// }
						}
						this.fileInputKey++;
						this.hideSectionTwoDiv = true;

						if(this.csvProspect.length) {
							this.csvProspect.filter(csvprosp => {
								var aa = this.prospects.find(uo1 => uo1.Number && uo1.Number == csvprosp.Number)
								if(csvprosp.Zip === undefined) { csvprosp['Zip'] = ''; }
								if(csvprosp.Notes === undefined) { this.$delete(csvprosp, 'Notes'); }
								if(aa) {
									this.CountExistingProspects = this.CountExistingProspects + 1;
									csvprosp['id'] = aa.id;
									this.ExistingProspectData.push(csvprosp);
								} else {
									this.CountNewProspects = this.CountNewProspects + 1;
									if(csvprosp.Notes) {
										let notesArray2 = [{
											'date': Date.now(),
											'description': csvprosp.Notes,
											'mediaURL': ''
										}];
										// let tempNote = {};
										// tempNote[Date.now()] = csvprosp.Notes;
										// csvprosp['Notes'] = tempNote;
										csvprosp['Notes'] = notesArray2;
									}
									csvprosp['DateCreated'] = Date.now();
									this.NewProspectData.push(csvprosp);
								}
							});
						}

						this.LoaderShow = false;
					
					} else {
						this.LoaderShow = false;
						alert('Import file must have First Name, Last Name and Status headings');
						this.fileInputKey++;
					}

				}
			},
			newProspectAdd() {
				this.NewProspectData.forEach(nwps => {
					this.TagsUpdate(nwps.Tags);
					this.StatusUpdate(nwps.Status);
					if(typeof nwps.Number === 'undefined') {
						nwps.Number = '';
					}
					//eslint-disable-next-line
					//console.log('newProspectAdd:', nwps);
					db.collection(`Users/${this.user.id}/Prospects`).add(nwps);
					this.createdNewProspects = this.createdNewProspects + 1;
				});
			},
			ImportSubmit() {
				if(this.collection.length) {
					// INSERT,UPDATE DATA ACCORDING TO VALIDATION
					if(this.radioValue) {
						this.LoaderShow = true;
						// Ignore (Data of existing prospects will be unchanged and no new data will be added)
						if(this.radioValue == 1) {
							// NEW PROSPECT ADD
							if(this.NewProspectData && this.NewProspectData.length) {
								this.newProspectAdd();
							}
						}
						// Update (Data of existing prospects will be unchanged, but a new Note will be added) Recommended
						if(this.radioValue == 2) {
							// ADD NEW PROSPECTS
							if(this.NewProspectData && this.NewProspectData.length) {
								this.newProspectAdd();
							}
							// UPDATE PROSPECTS (NOTES ONLY) 
							this.ExistingProspectData.filter(existprospdata => {
								let secondQuery = this.prospects.find(uo1 => uo1.Number && uo1.Number == existprospdata.Number)
								
								// NOTES
								/*
								let tempNote = {};
								tempNote[Date.now()] = existprospdata.Notes;
								Object.assign(tempNote,secondQuery.Notes);
								this.oldAndNewnotes = tempNote; // OLD NOTES + NEW NOTES
								*/
								if(existprospdata.Notes) {
									var notesArray1 = [];
									if(secondQuery.hasOwnProperty('Notes') || secondQuery.Notes != null || secondQuery.Notes != undefined) {
										notesArray1 = secondQuery.Notes;
									}
									let notesArray2 = [{
										'date': Date.now(),
										'description': existprospdata.Notes,
										'mediaURL': ''
									}];
									let notesFinalArray = [...notesArray1, ...notesArray2];
									this.oldAndNewnotes = notesFinalArray;
								}								

								if(existprospdata.Notes) {
									db.doc(`Users/${this.user.id}/Prospects/${existprospdata.id}`).update({ Notes: this.oldAndNewnotes });
									this.updatedProspects = this.updatedProspects + 1;
								}
							});
						}
						// Overwrite (All fields and data (except Phone Number and Email) will be overwritten to the values in import for 
						// the existing prospect(s). Existing Conversation and Message data will be unaffected.
						if(this.radioValue == 3) {
							// ADD NEW PROSPECTS
							if(this.NewProspectData && this.NewProspectData.length) {
								this.newProspectAdd();
							}
							// UPDATE PROSPECTS 
							this.ExistingProspectData.filter(existprospdata => {
								var thirdQuery = this.prospects.find(uo1 => uo1.Number && uo1.Number == existprospdata.Number)

								// NOTES
								if(existprospdata.Notes) {
									/*
									let tempNote = {};
									tempNote[Date.now()] = existprospdata.Notes;
									Object.assign(tempNote,thirdQuery.Notes);
									this.oldAndNewnotes = tempNote; // OLD NOTES + NEW NOTES
									existprospdata['Notes'] = this.oldAndNewnotes;
									*/
									var notesArray1 = [];
									if(thirdQuery.hasOwnProperty('Notes') || thirdQuery.Notes != null || thirdQuery.Notes != undefined) {
										notesArray1 = thirdQuery.Notes;
									}
									let notesArray2 = [{
										'date': Date.now(),
										'description': existprospdata.Notes,
										'mediaURL': ''
									}];
									let notesFinalArray = [...notesArray1, ...notesArray2];
									existprospdata['Notes'] = notesFinalArray;
								}
								
								// TAGS
								var oldNewtags = [...existprospdata.Tags,...thirdQuery.Tags];
								this.oldAndNewtags = [...new Set(oldNewtags)];

								this.$delete(existprospdata, 'Number');
								this.$delete(existprospdata, 'Email');

								this.StatusUpdate(existprospdata.Status);
								this.TagsUpdate(this.oldAndNewtags);

								// OLD TAGS + NEW TAGS
								existprospdata['Tags'] = this.oldAndNewtags; 										
								
								// UPDATE QUERY
								db.doc(`Users/${this.user.id}/Prospects/${existprospdata.id}`).update(existprospdata);
								this.updatedProspects = this.updatedProspects + 1;
							});
						}

						alert('Import Successfully');
						this.hideSectionTwoDiv=false;
						this.hideSectionThreeDiv=true;
						this.LoaderShow = false;
					}
					
				} else {
					alert('Please upload the .csv, .xlsx file');
				}
			},
			TagsUpdate(Tagss) {
				var neww1=[];
				Object.assign(neww1,Tagss);
				for(var ii=0; ii<neww1.length; ii++) {
					var convertCurrentStagesToUppercase = String(this.user.Folders).toUpperCase().split(","); // CONVERT ALL STAGES UPPER CASE
					var currentStageToUppercase = neww1[ii].toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
					if(neww1[ii]) { // CHECK VALUE BLANK OR NOT
						var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
						if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false) 
							this.user.Folders.push(neww1[ii]);
							db.doc(`Users/${this.user.id}`).update({ Folders: this.user.Folders});
							// neww1 = "";
						}
					}
				}
			},
			StatusUpdate(neww) {
				var convertCurrentStagesToUppercase = String(this.user.Stages).toUpperCase().split(","); // CONVERT ALL STAGES UPPER CASE
				var currentStageToUppercase = neww.toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
				if(neww) { // CHECK VALUE BLANK OR NOT
					var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
					if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false) 
						this.user.Stages.push(neww);
						db.doc(`Users/${this.user.id}`).update({ Stages: this.user.Stages});
						// neww = "";
					}
				}
			},
		},
		data() {
			return {
				oldAndNewnotes: [],
				oldAndNewtags: [],
				keyHeader:[],
				valueHeader:[],
				myResult:[],
				
				file: null,
				collection: [],
				NewProspectData:[],
				ExistingProspectData:[],
				CountNewProspects: 0,
				CountExistingProspects: 0,
				csvProspect:[],
				createdNewProspects: 0,
				updatedProspects: 0,
				fileInputKey: 0,
                hideSectionTwoDiv:false,
				hideSectionThreeDiv:false,
				SubmitImportbtn:false,
				InputFileHide:true,
				LoaderShow:false,
				radioValue:0,
                CSVDemoImage:'https://firebasestorage.googleapis.com/v0/b/tatext-thirdpool.appspot.com/o/Prospect_Import_Image.png?alt=media&token=88a1473f-e4c3-400d-83ff-ce4676e56bff',
                DownloadImportTemplate:'https://firebasestorage.googleapis.com/v0/b/tatext-thirdpool.appspot.com/o/Import%20Template.csv?alt=media&token=22f0b6d2-c097-4925-855e-79380d5bcb63',
            }
        }
    }
</script>

<style scoped>
.page-wrapper{
	height: 100vh;overflow-x: hidden;overflow-y: auto;
}
.custom-form{
	margin-bottom: 30px;
	background: rgb(242 242 242 / 30%);
	padding: 20px;
	box-shadow: 0px 0px 4px 0px #d3cfcf;
	border-radius: 3px;
	margin-top:20px;
}
.headingone{
    margin-bottom: 15px;
}
.headingtwo{
    margin: 5px 0px;
}
.headingthree{
    margin:30px 40px;
}
.headingthree img{
    width:100%;    
}
.DownloadImportTemplate{
	text-align: center;
	margin: 30px;
}
.DownloadImportTemplate .btn-outline-primary{
    padding: 10px 30px;
	height:40px;
	font-size: 12px;
}
.manageradiobox{
	padding:10px 0px 0px 0px;
}
.manageradiobox .containerradio {
	display: block;
	position: relative;
	padding-left: 30px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
.manageradiobox .containerradio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.manageradiobox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e1e1e1;
  border-radius: 50%;
}
.manageradiobox .containerradio:hover input ~ .checkmark {
  background-color: #ccc;
}
.manageradiobox .containerradio input:checked ~ .checkmark {
  background-color: #007bff;
}
.manageradiobox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.manageradiobox .containerradio input:checked ~ .checkmark:after {
  display: block;
}
.manageradiobox .containerradio .checkmark:after {
	top: 7px;
	left: 7px;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: white;
}
.ImportProspectInput{
	color: #007bff;
    background-color: transparent;
    border-color: #007bff;
	cursor: pointer;
	padding: 10px 30px;
	position: relative;
    overflow: hidden;
	font-size: 12px;
}
.ImportProspectInput.btn-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.ImportProspectInput input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;   
    cursor: inherit;
    display: block;
}

.loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
       border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}

</style>